import React from 'react';
import { useT } from '../lib/i18n';

const MAP = {
  draft: { bg: 'bg-gray-100', text: 'text-gray-700', border: 'border-gray-300' },
  pending: { bg: 'bg-amber-50', text: 'text-amber-800', border: 'border-amber-300' },
  accepted: { bg: 'bg-emerald-50', text: 'text-emerald-800', border: 'border-emerald-300' },
  refused: { bg: 'bg-red-50', text: 'text-red-800', border: 'border-red-300' },
  expired: { bg: 'bg-black', text: 'text-white', border: 'border-black' },
};

export function StatusBadge({ status }) {
  const { t } = useT();
  const s = MAP[status] || MAP.draft;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider border ${s.bg} ${s.text} ${s.border}`}
    >
      {t(`status.${status}`)}
    </span>
  );
}
